// extracted by mini-css-extract-plugin
module.exports = {"multiplierFormContainer":"AdUnitBasics_multiplierFormContainer__XBzjv","formula":"AdUnitBasics_formula__cPKfL","multiplierForm":"AdUnitBasics_multiplierForm__IMSHu"};